{
  "id": "skirmish_00",
  "name": "Skirmish-00",
  "mode": "HOTSEAT_2P",
  "ruleset": "OFFICIAL_SKIRMISH",
  "objective": "Oficiální cíl: soupeř prohrává, když mu nezůstane žádná figurka.",
  "randomStart": true,
  "credits": {"EFA": 20, "REDCAT": 20},
  "terrain": [
    "MMMGMMMGMM",
    "MMMMMWMOOW",
    "MFMMWMWFMG",
    "MMMWWMMMMM",
    "MGMWMMMMMM",
    "MMWMMMMMMM",
    "GOOGMMMMMM",
    "MWMMMMMMMM",
    "MVHVMVMVMV"
  ],
  "bridges": [
    [4, 3]
  ],
  "ore": [
    [1, 0], [2, 0], [0, 1], [1, 1], [2, 1],
    [7, 7], [8, 7], [9, 7], [9, 6], [8, 8]
  ],
  "pieces": [
    {"type": "MCV", "owner": "EFA", "col": 8, "row": 0},
    {"type": "MCV", "owner": "REDCAT", "col": 0, "row": 7}
  ]
}
